import { Button, Card, CardContent, Container, Grid, Link, Table, TableCell, TableRow, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
const ViewProjectContent = () => {
    const {projectid} = useParams();

    const [project, setPorject] = useState([]);

    useEffect(()=>{
        fetch(`https://immense-tor-98542.herokuapp.com/project/${projectid}`)
        .then(res => res.json())
        .then(data => setPorject(data))
    },[]);

    return (
        <Container>
            <Box sx={{ mt: 16, mb: 5 }}>
                <Box sx={{ mb: 5 }}>
                    <Typography variant='h3' style={{ 'textAlign': 'left', 'marginLeft': '50px' }}>
                        {project.name}
                    </Typography>
                </Box>
                <Box>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={8}>
                            <Box>
                                <img src={project.img} style={{ width: '100%' }}/>
                            </Box>
                            <Box sx={{ mt: 5 }}>
                                <Link href={project.website_link} target="_blank">
                                <Button variant='contained'>Preview</Button>
                                </Link>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Card>
                                <CardContent>
                                    <Table aria-label="simple table">
                                        <TableRow>
                                            <TableCell align="left">
                                                Last Update
                                            </TableCell>
                                            <TableCell align="left">
                                                7 December 21
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align="left">
                                                Published
                                            </TableCell>
                                            <TableCell align="left">
                                                7 December 21
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align="left">
                                                Layout
                                            </TableCell>
                                            <TableCell align="left">
                                                Responsive
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align="left">
                                                Description
                                            </TableCell>
                                            <TableCell align="left">
                                                {project.description}
                                            </TableCell>
                                        </TableRow>
                                    </Table>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Container>
    );
};

export default ViewProjectContent;